import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';

export const BearingSchema = new GenericModelSchema('bearing', {
  category: ModelCategory.ComponentDesignData,
  properties: {},
});
